import { render, staticRenderFns } from "./MovieItemList.vue?vue&type=template&id=e4da55e2&scoped=true&"
import script from "./MovieItemList.vue?vue&type=script&lang=js&"
export * from "./MovieItemList.vue?vue&type=script&lang=js&"
import style0 from "./MovieItemList.vue?vue&type=style&index=0&id=e4da55e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4da55e2",
  null
  
)

export default component.exports